module.exports = __webpack_public_path__ + "img/me.9c9d9bed.svg";